<chart [type]="type" [data]="data" [options]="options"></chart>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/nutritional-group/nutritional-group.component.html